import { toast } from "react-toastify";

export const toastError = (message: string) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    isLoading: false,
  });
};

export const toastSucess = (message: string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    isLoading: false,
  });
};

export const toastWarning = (message: string) => {
  toast.warning(message, {
    position: "top-right",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    isLoading: false,
  });
};

export const toastLoading = () => {
  toast.loading("carregando", {
    position: "top-right",
  });
};
